import { Pipe, PipeTransform } from '@angular/core';
import { TranslationService } from './translation';

@Pipe({
    name: 'translate',
    pure: false,
    standalone: false
})
export class TranslatePipe implements PipeTransform {
    constructor(private translations: TranslationService) {
    }

    transform(value: string) {
        return this.translations.translate(value);
    }
}
